<template>
  <section class="report-preview-section">
    <div class="report-preview-inner">
      <div class="section-eyebrow">{{ t('examples.eyebrow') }}</div>
      <h2 class="section-heading">{{ t('examples.title') }}</h2>
      <p class="section-sub">{{ t('examples.subtitle') }}</p>

      <div class="example-cards-grid">

        <!-- Model 3 -->
        <div class="example-card">
          <div class="example-card-header">
            <div class="example-card-model">{{ t('examples.profiles.model3') }}</div>
            <div class="example-card-title">Long Range AWD 2022</div>
            <div class="example-card-desc">{{ t('examples.profiles.model3Desc') }}</div>
          </div>
          <div class="example-card-stats">
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.soh') }}</span>
              <span class="example-stat-val green">94%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.serviceRecords') }}</span>
              <span class="example-stat-val">2</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.fastCharge') }}</span>
              <span class="example-stat-val blue">8%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.estRange') }}</span>
              <span class="example-stat-val">438 km</span>
            </div>
          </div>
          <div class="example-card-footer">
            <button class="example-btn-secondary" @click="viewDemo('model3')">{{ t('examples.viewInteractive') }}</button>
            <a href="/examples/tesla-report-model3.pdf" target="_blank" class="example-btn-primary">{{ t('examples.downloadPdf') }}</a>
          </div>
        </div>

        <!-- Model Y -->
        <div class="example-card">
          <div class="example-card-header">
            <div class="example-card-model">{{ t('examples.profiles.modelY') }}</div>
            <div class="example-card-title">Performance AWD 2023</div>
            <div class="example-card-desc">{{ t('examples.profiles.modelYDesc') }}</div>
          </div>
          <div class="example-card-stats">
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.soh') }}</span>
              <span class="example-stat-val green">97%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.serviceRecords') }}</span>
              <span class="example-stat-val">0</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.fastCharge') }}</span>
              <span class="example-stat-val blue">35%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.estRange') }}</span>
              <span class="example-stat-val">497 km</span>
            </div>
          </div>
          <div class="example-card-footer">
            <button class="example-btn-secondary" @click="viewDemo('modely')">{{ t('examples.viewInteractive') }}</button>
            <a href="/examples/tesla-report-modely.pdf" target="_blank" class="example-btn-primary">{{ t('examples.downloadPdf') }}</a>
          </div>
        </div>

        <!-- Model S - warning -->
        <div class="example-card card-warn">
          <div class="example-card-header">
            <div class="example-card-model amber">{{ t('examples.profiles.modelS') }}</div>
            <div class="example-card-title">Plaid 2021</div>
            <div class="example-card-desc">{{ t('examples.profiles.modelSDesc') }}</div>
          </div>
          <div class="example-card-stats">
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.soh') }}</span>
              <span class="example-stat-val amber">89%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.serviceRecords') }}</span>
              <span class="example-stat-val">3</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.fastCharge') }}</span>
              <span class="example-stat-val amber">55%</span>
            </div>
            <div class="example-stat-row">
              <span class="example-stat-label">{{ t('examples.specs.estRange') }}</span>
              <span class="example-stat-val">571 km</span>
            </div>
          </div>
          <div class="example-card-footer">
            <button class="example-btn-secondary" @click="viewDemo('models')">{{ t('examples.viewInteractive') }}</button>
            <a href="/examples/tesla-report-models.pdf" target="_blank" class="example-btn-primary">{{ t('examples.downloadPdf') }}</a>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/stores/app';
import { mockReportsData } from '@/data/mockReportsData';

const { t } = useI18n();
const store = useAppStore();

const viewDemo = (model: 'model3' | 'modely' | 'models') => {
  const report = mockReportsData[model];
  store.setVehicleReports({ [report.vehicle.vin]: report as any });
  store.setActiveReportVin(report.vehicle.vin);
  store.setStep('report');
};
</script>
